import { InMemoryCache } from 'apollo-cache-inmemory/lib/inMemoryCache'
import gql from 'graphql-tag'
import get from 'lodash-es/get'

export const postDefaults = {
  Post: {
    __typename: 'Post',
    expanded: false,
  }
}

export const postResolvers = {
  Post: {
    expanded: (obj, args, context) => {
      const cache = context.cache
      const post = cache.readFragment({
        fragment: gql`
          fragment expanded on Post { expanded }
        `,
        id: `Post:${obj.id}`})
      return get(post, 'expanded', false)
    }
  },
}

export const postMutations = {
  TogglePostExpandedMutation: (_, args: { id: number, expanded: boolean }, ctx: { cache: InMemoryCache }) => {
    ctx.cache.writeData({ id: `Post:${args.id}`, data: { expanded: args.expanded } })
    return null
  },
}
